module.exports = __webpack_public_path__ + "img/unknown.95b86338.png";